
// DEV
// var config = {
//     endpoint: "https://dev-online-api.tradebulls.in/",
//     // endpoint: "http://172.10.0.34:3021/",//Dev IP
//     contentendpoint: "https://dev-test.tradebulls.in",
//     diyendpoint: "https://dev-diy.tradebulls.in",
//     auth: "ms-trading-authservice/login",
//     loginWithOTP: "ms-trading-authservice/user/loginotp",
//     loginWithTOTP: "ms-trading-authservice/login2faTotp",
//     fgtPwd: "ms-trading-authservice/user/fgtpwd",
//     changePwd: "ms-trading-authservice/changepwd",
//     sendOtp: "ms-trading-authservice/sendOtp",
//     resendotp: "ms-trading-authservice/resendotp",
//     setpin: "ms-trading-authservice/createpin",
//     resetpin: "ms-trading-authservice/resetpin",
//     enterpin: "ms-trading-authservice/login2fa",
//     signout: "ms-trading-authservice/signout",
//     signout2FA: "ms-trading-authservice/logout2fa",
// }

// UAT
// var config = {
//     endpoint: "https://uat-online-api.tradebulls.in/",
//     algoendpoint: "https://uat-api-algo.tradebulls.in/",
//     contentendpoint: "https://uat-tbweb.tradebulls.in",
//     diyendpoint: "https://uat-diy.tradebulls.in",
//     strapiendpoint: "https://uat-cmsapi.tradebulls.in",
//     auth: "ms-trading-authservice/login",
//     algoauth: "ms-algo-trading-authservice/login",
//     loginWithOTP: "ms-trading-authservice/user/loginotp",
//     loginWithTOTP: "ms-trading-authservice/login2faTotp",
//     algologinWithTOTP: "ms-algo-trading-authservice/login2faTotp",
//     fgtPwd: "ms-trading-authservice/user/fgtpwd",
//     changePwd: "ms-trading-authservice/changepwd",
//     sendOtp: "ms-trading-authservice/sendOtp",
//     resendotp: "ms-trading-authservice/resendotp",
//     algosendOtp: "ms-algo-trading-authservice/sendOtp",
//     algoresendotp: "ms-algo-trading-authservice/resendotp",
//     setpin: "ms-trading-authservice/createpin",
//     resetpin: "ms-trading-authservice/resetpin",
//     enterpin: "ms-trading-authservice/login2fa",
//     signout: "ms-trading-authservice/signout",
//     signout2FA: "ms-trading-authservice/logout2fa",
//     cryptoKey: "3d541e5e-9594-11ee-b9d1-0242ac120002"
// };

// PROD
var config = {
  endpoint: "https://online-api.tradebulls.in/",
  algoendpoint: "https://api-algo.tradebulls.in/",
  contentendpoint: "https://tradebulls.in",
  diyendpoint: "https://diy.tradebulls.in",
  strapiendpoint: "https://cmsapi.tradebulls.in",
  auth: "ms-trading-authservice/login",
  algoauth: "ms-algo-trading-authservice/login",
  loginWithOTP: "ms-trading-authservice/user/loginotp",
  loginWithTOTP: "ms-trading-authservice/login2faTotp",
  algologinWithTOTP: "ms-algo-trading-authservice/login2faTotp",
  fgtPwd: "ms-trading-authservice/user/fgtpwd",
  changePwd: "ms-trading-authservice/changepwd",
  sendOtp: "ms-trading-authservice/sendOtp",
  resendotp: "ms-trading-authservice/resendotp",
  algosendOtp: "ms-algo-trading-authservice/sendOtp",
  algoresendotp: "ms-algo-trading-authservice/resendotp",
  setpin: "ms-trading-authservice/createpin",
  resetpin: "ms-trading-authservice/resetpin",
  enterpin: "ms-trading-authservice/login2fa",
  signout: "ms-trading-authservice/signout",
  signout2FA: "ms-trading-authservice/logout2fa",
  cryptoKey: "3d541e5e-9594-11ee-b9d1-0242ac120002"
};

export default config;
